import React from 'react';
import ReactECharts from 'echarts-for-react';
import artHero from '../images/Art-Hero.jpeg';
import kathmandu from '../images/Kathmandu.jpeg';
import nightCity from '../images/Nightcity.jpeg';
import winterfox from '../images/Winterfox.jpeg';
import arcade from '../images/Arcade.jpeg';

const dummyArtworks = [
  { title: 'After the Rain', artist: 'Maya Chen', image: artHero, chart: 'bar' },
  { title: 'Shangri La', artist: 'Daniel Okafor', image: kathmandu, chart: 'pie' },
  { title: 'Neon Night', artist: 'Sofia Bennett', image: nightCity, chart: 'radar' },
  { title: 'Winter Signal', artist: 'Eli Navarro', image: winterfox, chart: 'body' },
  { title: 'Zen Arcade', artist: 'Amara Lewis', image: arcade, chart: 'line' },
];

const chartOptions = {
  bar: {
    animationDuration: 900,
    grid: { left: 12, right: 12, top: 18, bottom: 24, containLabel: true },
    xAxis: { type: 'category', data: ['Positive', 'Neutral', 'Negative'], axisLabel: { color: '#6b7280', fontSize: 10 }, axisLine: { show: false }, axisTick: { show: false } },
    yAxis: { type: 'value', show: false },
    series: [{ type: 'bar', barWidth: '38%', data: [78, 46, 22], itemStyle: { borderRadius: [6, 6, 0, 0], color: '#111827' }, emphasis: { itemStyle: { color: '#20D5FF', shadowBlur: 12, shadowColor: 'rgba(32, 213, 255, 0.4)' } } }],
  },
  pie: {
    animationDuration: 900,
    tooltip: { trigger: 'item' },
    legend: { bottom: 0, left: 'center', itemWidth: 8, itemHeight: 8, textStyle: { color: '#6b7280', fontSize: 10 } },
    series: [{ type: 'pie', radius: ['42%', '68%'], center: ['50%', '43%'], label: { show: false }, itemStyle: { borderColor: '#fff', borderWidth: 3 }, emphasis: { scale: true, scaleSize: 6, itemStyle: { shadowBlur: 18, shadowColor: 'rgba(32, 213, 255, 0.45)' } }, data: [{ value: 58, name: 'Positive', itemStyle: { color: '#111827' } }, { value: 27, name: 'Neutral', itemStyle: { color: '#9ca3af' } }, { value: 15, name: 'Negative', itemStyle: { color: '#d1d5db' } }] }],
  },
  radar: {
    animationDuration: 900,
    radar: { radius: '62%', indicator: [{ name: 'Joy', max: 100 }, { name: 'Focus', max: 100 }, { name: 'Calm', max: 100 }, { name: 'Curiosity', max: 100 }, { name: 'Wonder', max: 100 }], axisName: { color: '#6b7280', fontSize: 10 }, splitArea: { areaStyle: { color: ['#fff', '#f9fafb'] } }, splitLine: { lineStyle: { color: '#e5e7eb' } }, axisLine: { lineStyle: { color: '#e5e7eb' } } },
    series: [{ type: 'radar', data: [{ value: [82, 68, 54, 91, 76], areaStyle: { color: 'rgba(17, 24, 39, 0.12)' }, lineStyle: { color: '#111827', width: 2 }, itemStyle: { color: '#111827' } }], emphasis: { lineStyle: { color: '#20D5FF', width: 3 }, areaStyle: { color: 'rgba(32, 213, 255, 0.2)' }, itemStyle: { color: '#20D5FF' } } }],
  },
  body: {
    animationDuration: 900,
    tooltip: { trigger: 'item' },
    legend: { bottom: 0, left: 'center', itemWidth: 8, itemHeight: 8, textStyle: { color: '#6b7280', fontSize: 10 } },
    series: [{ type: 'pie', radius: ['42%', '68%'], center: ['50%', '43%'], label: { show: false }, itemStyle: { borderColor: '#fff', borderWidth: 3 }, emphasis: { scale: true, scaleSize: 6, itemStyle: { shadowBlur: 18, shadowColor: 'rgba(32, 213, 255, 0.45)' } }, data: [{ value: 44, name: 'Still', itemStyle: { color: '#111827' } }, { value: 32, name: 'Engaged', itemStyle: { color: '#6b7280' } }, { value: 24, name: 'Moving', itemStyle: { color: '#d1d5db' } }] }],
  },
  line: {
    animationDuration: 900,
    grid: { left: 12, right: 12, top: 18, bottom: 24, containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: ['10am', '12pm', '2pm', '4pm', '6pm'], axisLabel: { color: '#6b7280', fontSize: 10 }, axisLine: { show: false }, axisTick: { show: false } },
    yAxis: { type: 'value', show: false },
    series: [{ type: 'line', smooth: true, data: [18, 42, 34, 71, 58], symbol: 'circle', symbolSize: 7, itemStyle: { color: '#111827' }, lineStyle: { color: '#111827', width: 3 }, areaStyle: { color: 'rgba(17, 24, 39, 0.08)' }, emphasis: { focus: 'series', itemStyle: { color: '#20D5FF', borderColor: '#fff', borderWidth: 2, shadowBlur: 12, shadowColor: 'rgba(32, 213, 255, 0.45)' }, lineStyle: { color: '#20D5FF', width: 4 }, areaStyle: { color: 'rgba(32, 213, 255, 0.16)' } } }],
  },
};

const FeaturedGraphsSection = ({ onAuthRequired }) => {
  const handleCardClick = () => onAuthRequired?.();

  return (
    <section className="w-full bg-white py-16" aria-labelledby="analytics-heading">
      <div className="w-full px-5 sm:px-8">
        <div className="mb-10 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-gray-500">A glimpse into the gallery</p>
            <h2 id="analytics-heading" className="text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">Artwork analytics</h2>
          </div>
          <p className="max-w-sm text-sm leading-6 text-gray-500">See the kinds of audience signals Artization brings into focus for every artwork.</p>
        </div>

        <div className="overflow-hidden pb-5 pt-2">
          <div className="analytics-marquee flex min-w-max gap-5">
            {[...dummyArtworks, ...dummyArtworks].map((artwork, index) => (
              <button
                key={`${artwork.title}-${index}`}
                type="button"
                onClick={handleCardClick}
                className="group w-[275px] overflow-hidden rounded-xl border border-gray-200 bg-white text-left shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 sm:w-[300px]"
              >
                <div className="h-[230px] bg-gray-50 p-3">
                  <div className="h-full overflow-hidden rounded-lg bg-gray-100">
                    <ReactECharts option={chartOptions[artwork.chart]} notMerge style={{ height: '100%', width: '100%' }} />
                  </div>
                </div>
                <div className="flex items-center gap-3 border-t border-gray-100 p-4">
                  <img src={artwork.image} alt="" className="h-12 w-12 rounded-lg object-cover grayscale transition duration-300 group-hover:grayscale-0" />
                  <span className="min-w-0">
                    <span className="block truncate text-sm font-semibold text-gray-900">{artwork.title}</span>
                    <span className="mt-1 block truncate text-xs text-gray-500">{artwork.artist}</span>
                  </span>
                  <span className="ml-auto text-gray-400 transition group-hover:translate-x-1 group-hover:text-gray-900" aria-hidden="true">→</span>
                </div>
              </button>
            ))}
          </div>
        </div>
        <p className="mt-1 text-center text-xs text-gray-400 sm:text-left">Scroll to explore featured artwork signals</p>
      </div>
    </section>
  );
};

export default FeaturedGraphsSection;
